export default __webpack_public_path__ + "static/media/osobni-doucovani-banner-mobile.4338541f.png";